import { useState, useEffect } from 'react';
import { Modal } from '@prosolve/common-components-ui'
import CloseModalConfirmation from './CloseModalConfirmation';

export default ({
  surveyData = {},
  onClose 
}) => {
  const {
    linkUrl = ''
  } = surveyData;

  useEffect(() => {
    const allowedOrigins = [
      "http://localhost:3000",
      "http://localhost",
      "https://go.qa.prosolve.com",
      "https://go.uat.prosolve.com",
      "https://go.prosolve.com"
    ];

    const handler = (event) => {
      if (!allowedOrigins.includes(event.origin)) {
        console.log(`Blocked message from disallowed origin: ${event.origin}`);
        return;
      }

      if (event.data?.type === 'SURVEY_COMPLETE') {
        onClose(event, linkUrl)
      }
    }

    window.addEventListener('message', handler);

    return () => {
      window.removeEventListener('message', handler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // const [isLoading, setIsLoading] = useState(true)

  // useEffect(() => {
  //   setTimeout(() => {
  //     setIsLoading(false)
  //   }, 5000)
  // }, [])

  const [showConfirmation, setShowConfirmation] = useState(false)

  return (
    <Modal isTrueFullScreen={true} noContentPadding={true} absoluteHeader={true} onClose={() => setShowConfirmation(true)}>
      <div style={{
        display: 'flex',
        flex: 1,
        height: 'calc(100vh)', 
        padding: '0px',
      }}>
        {
          showConfirmation &&
          <CloseModalConfirmation onClose={() => setShowConfirmation(false)} onConfirmation={onClose} />
        }
        {/* <div style={{ 
            width: '100%', 
            height: '100%',
            background: 'red',
            display: isLoading ? 'block' : 'none'
          }}>
          {'Loading'}
        </div> */}
        <iframe
          title='survey-link'
          src={linkUrl}
          style={{ 
            // visibility: isLoading ? 'hidden' : 'visible',
            width: '100%', 
            height: '100%',
            border: 'none',
          }}
        >
        </iframe>
      </div>
    </Modal>
  )
}